import { AxiosInstance } from "axios";
import { StorefrontProduct } from "../models/storefront";

const MERCHANDISE_API_PREFIX = "/merchandise/storefront";

export async function getProducts(
	http: AxiosInstance
): Promise<StorefrontProduct[]> {
	const body = await http.get<any>(`${MERCHANDISE_API_PREFIX}/products`);
	return (body.data || []) as StorefrontProduct[];
}

export async function getProductById(
	http: AxiosInstance,
	productId: number
): Promise<StorefrontProduct | null> {
	const body = await http.get<any>(
		`${MERCHANDISE_API_PREFIX}/products/${productId}`
	);
	return (body.data || null) as StorefrontProduct | null;
}
